<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-12 p-4 mb-5">

      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Listado de reporte encuesta</label>
        </div>
        <p>
          <button type="button" class="btn btn-outline-success mr-3" [disabled]="!dataTabla.items || dataTabla.items.length === 0"
            (click)="submit()">Exportar</button>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </p>
      </div>
      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group" *ngIf="!authService.getRolUser(adminCC)">
                  <label class="small text-secondary required" for="codigo_camara">Cámara de comercio</label>
                  <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara"
                    (change)="cargarListaFuncionario()">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of camarasLista; let i = index"
                      value="{{option?.codigo_camara}}" [selected]="false">
                      {{option?.desc_camara}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary required" for="categoria_id">Categoría</label>
                  <select class="form-control form-control-sm" id="categoria_id" formControlName="categoria_id"
                    (change)="onSubcategoriaSelect()">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of categoria; let i = index" value="{{option?.categoria_id}}"
                      [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary required" for="sub_categoria_id">Subcategoría</label>
                  <select class="form-control form-control-sm" id="sub_categoria_id" formControlName="sub_categoria_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of sub_categoria; let i = index"
                      value="{{option?.sub_categoria_id}}" [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="text-secondary small required">Año</label>
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm" #anio="bsDatepicker"
                      (onShown)="onOpenCalendar($event)" bsDatepicker placeholder="yyyy"
                      [bsConfig]="{dateInputFormat: 'YYYY', containerClass: 'theme-dark-blue'}" required>
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="anio.toggle()" type="button"></button>
                    </div>
                  </div>
                </div>
                <div class="col-2 form-group">
                  <label class="text-secondary small">Nit</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="nit" placeholder="nit">
                  </div>
                </div>
                <div class="col-2 form-group">
                  <label class="text-secondary small">Número de mátricula</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="matricula" placeholder="Mátricula">
                  </div>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="estado_solicitud">Estado solicitud</label>
                  <select class="form-control form-control-sm" id="estado_solicitud"
                    formControlName="estado_solicitud_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of estado_solicitud; let i = index"
                      value="{{option?.estado_solicitud_id}}" [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="text-secondary small">Razón social</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="razon_social"
                      placeholder="Razón social">
                  </div>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="tipo_rnt">Tipo RNT</label>
                  <select class="form-control form-control-sm" id="tipo_rnt" formControlName="tipo_rnt_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of tipos_rnt; let i = index" value="{{option?.tipo_rnt_id}}"
                      [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="text-secondary small">Código RNT</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="codigo_rnt" placeholder="Rnt">
                  </div>
                </div>
                <div class="col-2 form-group">
                  <label class="text-secondary small">Número de radicado</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="numero_radicado"
                      placeholder="Número de radicado">
                  </div>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="funcionario">Funcionario</label>
                  <select class="form-control form-control-sm" id="funcionario" formControlName="funcionario_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of listaFuncionarios; let i = index"
                      value="{{option?.funcionario_id}}" [selected]="false">
                      {{option?.nombres}} {{option?.apellidos}}
                    </option>
                  </select>
                </div>
                <div class="d-flex flex-row">
                  <button type="button" class="btn btn-outline-primary border-0 m-auto btn-align-vertical"
                    (click)="limpiar(); anio.bsValue = null;">Limpiar</button>
                  <button class="btn btn-primary m-auto solicitud-btn-principal btn-align-vertical" type="submit"
                    [disabled]="!filtro.valid">Filtrar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-hover" *ngIf="header">
          <thead>
            <tr>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.descripcion_tipo_rnt}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.codigo_rnt}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.descripcion_estado_rnt}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.numero_radicado}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.numero_identificacion}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.razon_social}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.matricula}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.fecha_matricula}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.fecha_renovacion_matricula}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.fecha_renovacion_Rnt}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.nombre_gerente}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.nombre_funcionario}}</label>
              </th>
              <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                [rowSpan]="header.maxFila">
                <label>{{header.anio_encuesta}}</label>
              </th>
              <ng-container *ngFor="let modulo of header.modulos; let i = index">
                <th class="border-top-0 border-left pb-1 small font-weight-bold" scope="col"
                  [colSpan]="modulo.columnSpan">
                  {{modulo.descripcion}}
                  <!-- <label>{{modulo.descripcion}}</label> -->
                </th>
              </ng-container>
            </tr>
            <tr>
              <!-- <th class="border-top-0 pb-1 small font-weight-bold" scope="col" [colSpan]="13">
              </th> -->
              <ng-container *ngFor="let modulo of header.modulos; let i = index">
                <ng-container *ngFor="let seccion of modulo.secciones; let j = index">
                  <th class="border-top-0 border-left pb-1 small font-weight-bold" scope="col"
                    [colSpan]="seccion.columnSpan">
                    {{seccion.descripcion}}
                    <!-- <label>{{seccion.descripcion}}</label> -->
                  </th>
                </ng-container>
              </ng-container>
            </tr>
            <tr>
              <!-- <th class="border-top-0 pb-1 small font-weight-bold" scope="col" [colSpan]="13">
              </th> -->
              <ng-container *ngFor="let modulo of header.modulos">
                <ng-container *ngFor="let seccion of modulo.secciones">
                  <ng-container *ngFor="let pregunta of seccion.preguntas">
                    <th class="border-top-0 border-left pb-1 small font-weight-bold" scope="col">
                      {{pregunta.descripcion}}
                      <!-- <label>{{pregunta.descripcion}}</label> -->
                    </th>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tr>
          </thead>
          <tfoot *ngIf="dataTabla.items && dataTabla.items.length > 0; else sinPaginado">
            <tr>
              <td colspan="100%">
                <ngb-pagination class="d-flex justify-content-center" [collectionSize]="dataTabla.paging.totalItems"
                  [pageSize]="dataTabla.paging.pageSize" (pageChange)="onPaginado($event)"
                  [(page)]="dataTabla.paging.pageNumber" [maxSize]="5" [rotate]="true" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
              </td>
            </tr>
          </tfoot>
          <ng-template #sinPaginado>
            <tfoot>
              <label class="text-muted">Sin registros</label>
            </tfoot>
          </ng-template>
          <ng-container *ngFor="let item of dataTabla.items; let i=index">
            <tr class="small">
              <td>
                <label>{{item.descripcion_tipo_rnt}}</label>
              </td>
              <td>
                <label>{{item.codigo_rnt}}</label>
              </td>
              <td>
                <label>{{item.descripcion_estado_rnt}}</label>
              </td>
              <td>
                <label>{{item.numero_radicado}}</label>
              </td>
              <td>
                <label>{{item.numero_identificacion}}</label>
              </td>
              <td>
                <label>{{item.razon_social}}</label>
              </td>
              <td>
                <label>{{item.matricula}}</label>
              </td>
              <td>
                <label>{{item.fecha_matricula}}</label>
              </td>
              <td>
                <label>{{item.fecha_renovacion_matricula}}</label>
              </td>
              <td>
                <label>{{item.fecha_renovacion_Rnt}}</label>
              </td>
              <td>
                <label>{{item.nombre_gerente}}</label>
              </td>
              <td>
                <label>{{item.nombre_funcionario}}</label>
              </td>
              <td>
                <label>{{item.anio_encuesta}}</label>
              </td>
              <ng-container *ngFor="let dato of getEntries(item.respuestas)">
                <td [innerHTML]="dato.respuesta"></td>
              </ng-container>
            </tr>
          </ng-container>
        </table>
      </div>
    </section>
  </article>
</main>
